/* eslint-disable react/no-children-prop */
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { getAcessoriesDetails, getBannerDetails } from "./requestCall";
import { Card, CardContent, CardMedia, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { v4 } from "uuid";
import { useParams } from "react-router-dom";
import { CenteredTextWithUnderline } from "../../shared/components/reusableComp/CenteredTextWithUnderline";
import Markdown from "markdown-to-jsx";
import MultipleSlides from "./MultipleSlides";
import AddCircularIcon from "../../shared/components/reusableComp/AddCircularIcon";

const streamDetailWrapper = css`
  width: 100%;
  background: #121212;
`;
const descriptionWrapper = css`
  font-size: 14px;
  line-height: 35px;
`;
const bannerDes = (matches) => css`
  margin-left: ${matches ? "20px" : "35px"};
  font-size: 14px;
  line-height: 35px;
`;
const bannerTitle = (matches, theme) => css`
  margin-left: ${matches ? "20px" : "35px"};
  font-family: ${theme.typography.MBCORPOA};
  font-size: 60px;
`;
const streamDetailContentWrapper = css`
  padding-bottom: 50px;
  margin: 0 2%;
  img,
  video {
    width: 100%;
  }
`;

const bannerHeadingStyle = (matches, cond) => css`
  position: absolute;
  bottom: ${matches ? "84%" : "35%"};
  display: ${!cond && "none"};
`;
const cardWrapper = (direction, isImageRequiredOnRight) => css`
  background: #121212;
  .MuiBox-root {
    display: flex;
    align-items: center;
    img {
      width: ${direction === "row" ? "50%" : "100%"};
      order: ${direction === "row" && isImageRequiredOnRight === true ? 2 : -1};
    }
    .MuiCardContent-root {
      padding: 0;
      margin: 20px 0;
      width: ${direction === "row" ? "50%" : "100%"};
      .MuiTypography-root {
        margin: ${direction === "column" ? "10px 20px" : "20px 10px"};
        color: white;
      }
    }
  }
`;

const rowImageStyle = css`
  :first-of-type {
    margin-right: 3%;
  }
`;

const singleContainerStyle = (matches) => css`
  margin: ${!matches && "0 14%"};
  display: flex;
  flex-wrap: wrap;

  > div {
    flex: ${matches && "48%"};
  }
`;

const imageBlockStyle = css`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: auto auto auto;
  column-gap: 2%;
  margin: 0 3%;
`;
const fontFamilyWrapper = (theme) => css`
  font-family: ${theme.typography.MBCORPOS};
`;
const renderCard = (
  isExternalLink,
  imgUrl,
  imgName,
  title,
  description,
  direction,
  isImageRequiredOnRight,
  buttonText,
  buttonLink,
  titleUnderlined
) => {
  return (
    <Card css={() => cardWrapper(direction, isImageRequiredOnRight)} key={v4()}>
      <Box
        sx={{
          display: "flex",
          flexDirection: direction === "row" ? "row" : "column",
        }}
      >
        {imgUrl && (
          <CardMedia
            component="img"
            image={`${process.env.REACT_APP_BASEURL}${imgUrl}`}
            alt={imgName}
          />
        )}
        <CardContent>
          {titleUnderlined ? (
            <CenteredTextWithUnderline
              title={title}
              description={description}
              bottomMargin="1px"
              titleVariant="h5"
            />
          ) : (
            <>
              <Typography
                variant="h5"
                component="span"
                display="block"
                css={fontFamilyWrapper}
              >
                {title}
              </Typography>
              <Typography
                css={descriptionWrapper}
                variant="body2"
                color="text.secondary"
              >
                <Markdown>{description || ""}</Markdown>
              </Typography>
            </>
          )}
          {buttonText && (
            <AddCircularIcon
              buttonCss="margin-top: 20px;font-size: medium; margin-left: 10px;"
              handleClick={() =>
                buttonLink &&
                (isExternalLink
                  ? window.open(buttonLink)
                  : (window.location = buttonLink))
              }
              buttonText={buttonText}
              iconCss={{
                width: "20px",
                height: "20px",
                marginRight: "10px",
                padding: "4px",
              }}
            />
          )}
        </CardContent>
      </Box>
    </Card>
  );
};

const renderBanner = (
  bannerDetail,
  matches,
  repeatedImageTextTiles,
  imageTextTile,
  rowOrientedImageTile,
  singleImageTile,
  carouselBody,
  imageBlockTile
) => {
  return (
    <Box css={streamDetailContentWrapper}>
      {bannerDetail && (
        <Box key={v4()} sx={{ display: "flex", flexDirection: "column" }}>
          {bannerDetail[0]?.bannerVideoSource ? (
            <video
              controls="controls"
              autoPlay
              src={bannerDetail[0]?.bannerVideoSource}
            />
          ) : (
            bannerDetail[0]?.bannerImage?.data?.attributes?.url && (
              <img
                src={`${process.env.REACT_APP_BASEURL}${bannerDetail[0]?.bannerImage?.data?.attributes?.url}`}
              />
            )
          )}
          {bannerDetail[0]?.textTiles?.map((textTile) => (
            <Box
              key={v4()}
              mb={2}
              css={() =>
                !matches &&
                bannerHeadingStyle(
                  matches,
                  bannerDetail[0]?.bannerVideoSource ||
                    bannerDetail[0]?.bannerImage?.data?.attributes?.url
                )
              }
            >
              <Typography
                css={(theme) => bannerTitle(matches, theme)}
                key={v4()}
                variant="h2"
                sx={{ color: "white" }}
              >
                {textTile.heading}
              </Typography>
              <Typography css={() => bannerDes(matches)} key={v4()}>
                <Markdown style={{ fontSize: "18px" }}>
                  {textTile?.description || ""}
                </Markdown>
              </Typography>
            </Box>
          ))}

          {bannerDetail[1]?.bannerVideoSource ? (
            <video
              controls="controls"
              autoPlay
              src={bannerDetail[1]?.bannerVideoSource}
            />
          ) : (
            bannerDetail[1]?.bannerImage?.data?.attributes?.url && (
              <img
                src={`${process.env.REACT_APP_BASEURL}${bannerDetail[1]?.bannerImage?.data?.attributes?.url}`}
              />
            )
          )}
          {bannerDetail[1]?.textTiles?.map((textTile) => (
            <Box key={v4()} sx={{ margin: "2% 0" }}>
              <Typography
                key={textTile.id}
                variant="h5"
                sx={{ color: "white", marginLeft: matches ? "20px" : "35px" }}
              >
                {textTile.heading}
              </Typography>
              <Typography css={() => bannerDes(matches)} key={v4()}>
                <Markdown>{textTile?.description || ""}</Markdown>
              </Typography>
            </Box>
          ))}
        </Box>
      )}
      {carouselBody && (
        <MultipleSlides
          industryCardData={carouselBody[0]?.Carousel}
          cardsPerView={4.3}
          title={carouselBody[0]?.title}
          description={carouselBody[0]?.description}
        />
      )}
      <Box>
        {repeatedImageTextTiles?.map((dataItem) => (
          <Box
            key={v4()}
            onClick={() => {
              if (matches) {
                window.location = dataItem?.buttonLink;
              }
            }}
          >
            {renderCard(
              dataItem?.isExternalLink,
              dataItem?.image?.data?.attributes?.url,
              dataItem?.image?.data?.attributes?.name,
              dataItem?.title,
              dataItem?.description,
              matches ? "column" : "row",
              dataItem?.isImageRequiredOnRight,
              dataItem?.buttonText,
              dataItem?.buttonLink
            )}
          </Box>
        ))}
      </Box>

      <Box sx={{ margin: !matches && "0 14%" }}>
        {imageTextTile?.map((dataItem) =>
          renderCard(
            dataItem?.isExternalLink,
            dataItem?.image?.data?.attributes?.url,
            dataItem?.image?.data?.attributes?.name,
            dataItem?.title,
            dataItem?.description,
            matches ? "column" : "row",
            dataItem?.isImageRequiredOnRight
          )
        )}

        <Box sx={{ display: !matches && "flex", marginTop: "3%" }}>
          {rowOrientedImageTile?.map((dataItem) => (
            <Box
              key={v4()}
              sx={!matches && rowImageStyle}
              css={{ width: !matches && "50%" }}
            >
              {renderCard(
                dataItem?.isExternalLink,
                dataItem?.image?.data?.attributes?.url,
                dataItem?.image?.data?.attributes?.name,
                dataItem?.title,
                dataItem?.description,
                matches ? "column" : "column46",
                dataItem?.isImageRequiredOnRight,
                dataItem?.buttonText,
                dataItem?.buttonLink
              )}
            </Box>
          ))}
        </Box>
      </Box>

      <Box css={imageBlockStyle}>
        {imageBlockTile &&
          imageBlockTile.map(({ title, description, image }) => (
            <Card key={v4()} css={{ background: "#121212", color: "white" }}>
              <Box>
                {image?.data && (
                  <CardMedia
                    component="img"
                    image={`${process.env.REACT_APP_BASEURL}${image?.data?.attributes?.url}`}
                    alt={image?.data?.attributes?.name}
                    css={{ minHeight: "161px" }}
                  />
                )}
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    {title}
                  </Typography>

                  <Markdown css={descriptionWrapper}>
                    {description || ""}
                  </Markdown>
                </CardContent>
              </Box>
            </Card>
          ))}
      </Box>

      <Box css={() => singleContainerStyle(matches)}>
        {singleImageTile?.map((dataItem) => (
          <Box key={v4()} sx={rowImageStyle}>
            {renderCard(
              dataItem?.isExternalLink,
              dataItem?.image?.data?.attributes?.url,
              dataItem?.image?.data?.attributes?.name,
              dataItem?.title,
              dataItem?.description,
              "column",
              dataItem?.isImageRequiredOnRight,
              dataItem?.buttonText,
              dataItem?.buttonLink,
              true
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

const IndustryDetailPage = ({ Slug }) => {
  const { slug } = useParams();
  const pathname = window.location.pathname.split("/")[2];

  window.scrollTo(0, 0);

  const [bannerDetail, setBannerDetail] = useState();
  const [repeatedImageTextTiles, setRepeatedImageTexTile] = useState();
  const [rowOrientedImageTile, setRowOrientedImageTile] = useState();
  const [singleImageTile, setSingleImageTile] = useState();
  const [imageTextTile, setImageTexTile] = useState();
  const [carouselBody, setCarouselBody] = useState();
  const [imageBlockTile, setImageBlockTile] = useState();
  const matches = useMediaQuery("(max-width: 415px)");

  useEffect(() => {
    const funcToBeCalled =
      pathname === "industry-detail-pages"
        ? getBannerDetails
        : getAcessoriesDetails;
    slug &&
      funcToBeCalled(slug || Slug).then((res) => {
        document.title = res?.data?.data?.attributes?.title;
        const banner = res?.data?.data?.attributes?.body?.filter(
          (item) =>
            item.__component === "components.banner-image-with-text-tiles"
        );
        setBannerDetail(banner);
        const repeatedImageTextTilesOnly =
          res?.data?.data?.attributes?.body?.filter(
            (item) =>
              item.__component === "components.repeated-image-text-tile" &&
              !item.rowOrientation &&
              !item.isSingle
          );
        setRepeatedImageTexTile(repeatedImageTextTilesOnly);

        const rowOrientedImageTilesOnly =
          res?.data?.data?.attributes?.body?.filter(
            (item) =>
              item.__component === "components.repeated-image-text-tile" &&
              item.rowOrientation &&
              !item.isSingle
          );
        setRowOrientedImageTile(rowOrientedImageTilesOnly);

        const imageBlockTilesOnly = res?.data?.data?.attributes?.body?.filter(
          (item) => item.__component === "components.image-block"
        );
        setImageBlockTile(imageBlockTilesOnly[0]?.imageComp);

        const singleImageTilesOnly = res?.data?.data?.attributes?.body?.filter(
          (item) =>
            item.__component === "components.repeated-image-text-tile" &&
            item.isSingle
        );
        setSingleImageTile(singleImageTilesOnly);

        const imageTextTilesOnly = res?.data?.data?.attributes?.body?.filter(
          (item) => item.__component === "components.image-text-tiles"
        );
        setImageTexTile(imageTextTilesOnly);
        const carousel = res?.data?.data?.attributes?.body?.filter(
          (item) => item.__component === "components.multi-carousel"
        );
        setCarouselBody(carousel);
      });
  }, [slug]);

  return (
    <Box css={streamDetailWrapper}>
      {renderBanner(
        bannerDetail,
        matches,
        repeatedImageTextTiles,
        imageTextTile,
        rowOrientedImageTile,
        singleImageTile,
        carouselBody,
        imageBlockTile
      )}
    </Box>
  );
};
export default IndustryDetailPage;
